import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect, useRef } from 'react';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const navigationPerformed = useRef(false);

  useEffect(() => {
    // Only check if user is connected, don't check for username
    if (!user?.isConnected && !navigationPerformed.current) {
      navigationPerformed.current = true;
      navigate('/', { replace: true });
    }

    // Mark username modal as shown for all users to prevent it from appearing
    if (user?.address) {
      localStorage.setItem(`username_modal_shown_${user.address}`, 'true');
    }
  }, [user, navigate]);

  // Show loading or nothing while navigation is happening
  if (!user?.isConnected) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
